import { render, staticRenderFns } from "./CustomerYanGuangJianCha.vue?vue&type=template&id=32a654fe&scoped=true&"
import script from "./CustomerYanGuangJianCha.vue?vue&type=script&lang=js&"
export * from "./CustomerYanGuangJianCha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a654fe",
  null
  
)

export default component.exports